import { useInfiniteQuery } from "@tanstack/react-query"
import { client } from "@/api"
import queryKeys from "@/api/queryKeys"

function useListPaginatedEvents({
  filters,
}: {
  filters: Omit<
    {
      type: string
      page: number
      pageSize: number
      searchValue: string
      filterValue: string[]
      ageRange: string
      petFriendly?: string
      price: string
    },
    "page"
  >
}) {
  return useInfiniteQuery({
    queryKey: queryKeys.events.listPage({ ...filters }).queryKey,
    queryFn: ({ pageParam = 1 }) =>
      client
        .get(`/events`, {
          params: {
            ...filters,
            page: pageParam,
          },
        })
        .then((res) => res.data),
    getNextPageParam: (lastPage, allPages) => {
      // Customize this depending on your API's response structure
      const hasMore = lastPage.hasMore || lastPage.totalPages > allPages.length
      return hasMore ? allPages.length + 1 : undefined
    },
    initialPageParam: 1,
  })
}

export default useListPaginatedEvents
